export enum LogType {
    Info,
    Warning,
    Error,
    Fatal
}
